import React, { useMemo } from "react";
import trans from "../../../../../../utils";
import { Input, TextAreaInput } from "../../../../../Helpers/Input/Input";
import { useGetAllCustomersQuery } from "../../../../../../Redux/service/Customer/Customer";
import { DatePicker, Space } from "antd";
import { InputSelect } from "../../../../../Helpers/Input/RefactoredInput";
import Dropfile from "../../../../../Helpers/Dropzone/Dropzone";
import POIsLogo from "../../../../../POIs/POIsForm/Extra/POIsLogo";
import dayjs from "dayjs";
import { useGetAllformsQuery } from "../../../../../../Redux/service/Forms/Form";

export default function ProjectDetails({ addPOI }) {
	const { data } = useGetAllCustomersQuery({ page: 1, limit: 10000 });
	const projectType = [
		{ label: "Buildings", value: "buildings" },
		{ label: "Infrastructure", value: "infrastructure" },
		{ label: "Roads", value: "roads" },
		{ label: "MEP", value: "MEP" },
		{ label: "MixedUse", value: "mixedUse" },
	];
	const projectStatus = [
		{ label: "Active", value: "active" },
		{ label: "On Hold", value: "onHold" },
		{ label: "Completed", value: "completed" },
		{ label: "Planning Phase", value: "planningPhase" },
	];
	const formCategory = [
		{ label: "IR", value: "IR" },
		{ label: "NCR", value: "NCR" },
		{ label: "MIR", value: "MIR" },
	];
	const { data: forms } = useGetAllformsQuery({
		page: 1,
		limit: 100000,
		queryString: `category=${addPOI.values.formCategory}&isActive=true`,
	});
	const startDateValue = useMemo(() => {
		return addPOI.values.startDate ? dayjs(addPOI.values.startDate) : null;
	}, [addPOI.values.startDate]);
	const endDateValue = useMemo(() => {
		return addPOI.values.endDate ? dayjs(addPOI.values.endDate) : null;
	}, [addPOI.values.endDate]);
	const disabledEndDate = useMemo(() => {
		if (!addPOI.values.startDate) return undefined;

		const start = dayjs(addPOI.values.startDate);

		return (current) => {
			if (!current) return false;
			return current.isSame(start, "day") || current.isBefore(start, "day");
		};
	}, [addPOI.values.startDate]);
	return (
		<div style={{ paddingInline: "8px" }}>
			<div style={{ fontWeight: "600", fontSize: "16px" }}>
				{trans("Project Details")}
			</div>
			<div
				style={{
					maxHeight: "calc(100vh - 415px)",
					overflowY: "auto",
					overflowX: "hidden",
					backgroundColor: "#d9d9d920",
				}}
			>
				<Input
					title={trans("Project Name")}
					type="text"
					placeholder={trans("Enter project name")}
					id="name"
					name="name"
					formstyle="mt-3 mb-2"
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(e) => addPOI.handleChange(e)}
					errors={addPOI.errors.name}
					touched={addPOI.touched.name}
					value={addPOI.values.name || ""}
				/>
				<Input
					title={trans("Project Code")}
					type="text"
					placeholder={trans("Enter project code")}
					id="code"
					name="code"
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(e) => addPOI.handleChange(e)}
					errors={addPOI.errors.code}
					touched={addPOI.touched.code}
					value={addPOI.values.code || ""}
				/>
				<InputSelect
					label="Project Type"
					id="projectType"
					name="projectType"
					placeholder={trans("Select project type")}
					className="w-100"
					style={{ width: "100%" }}
					formstyle="my-2"
					options={projectType?.map((i) => ({
						label: trans(i?.label),
						value: i?.value,
					}))}
					errors={addPOI.errors.projectType}
					touched={addPOI.touched.projectType}
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(val) => addPOI.setFieldValue("projectType", val)}
					value={addPOI.values.projectType || undefined}
				/>
				<InputSelect
					label="Project Status"
					id="projectStatus"
					name="projectStatus"
					placeholder={trans("Select project status")}
					className="w-100"
					style={{ width: "100%" }}
					options={projectStatus?.map((i) => ({
						label: trans(i?.label),
						value: i?.value,
					}))}
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(val) => addPOI.setFieldValue("projectStatus", val)}
					value={addPOI.values.projectStatus || undefined}
				/>
				<InputSelect
					label="Form Category"
					id="formCategory"
					name="formCategory"
					placeholder={trans("Select form category")}
					className="w-100"
					style={{ width: "100%" }}
					formstyle="my-2"
					options={formCategory?.map((i) => ({
						label: trans(i?.label),
						value: i?.value,
					}))}
					errors={addPOI.errors.formCategory}
					touched={addPOI.touched.formCategory}
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(val) => addPOI.setFieldValue("formCategory", val)}
					value={addPOI.values.formCategory ?? undefined}
				/>
				<InputSelect
					label="Form"
					id="forms"
					name="forms"
					placeholder={trans("Select form")}
					className="w-100"
					style={{ width: "100%" }}
					options={forms?.data?.map((i) => ({
						label: i?.name,
						value: i?.id,
					}))}
					errors={addPOI.errors.forms}
					touched={addPOI.touched.forms}
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(val) => addPOI.setFieldValue("forms", val)}
					disabled={!addPOI.values.formCategory}
				/>
				<TextAreaInput
					title={trans("Description")}
					placeholder={trans("Enter project description")}
					id="notes"
					name="notes"
					formstyle="my-2"
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(e) => addPOI.handleChange(e)}
					touched={addPOI.touched.notes}
					errors={addPOI.errors.notes}
					value={addPOI.values.notes || undefined}
				/>
				<InputSelect
					label="Customer Name"
					id="contactPerson.name"
					name="contactPerson.name"
					placeholder={trans("Select customer")}
					className="w-100"
					style={{ width: "100%" }}
					options={data?.data.map((i) => ({
						label: i?.name,
						value: i?.name,
					}))}
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(val) => addPOI.setFieldValue("contactPerson.name", val)}
					value={addPOI?.values.contactPerson?.name || undefined}
				/>
				<Input
					title={trans("Project Location")}
					type="text"
					placeholder={trans("Enter project location")}
					id="address"
					name="address"
					formstyle="my-2"
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(e) => addPOI.handleChange(e)}
					errors={addPOI.errors.address}
					touched={addPOI.touched.address}
					value={addPOI.values.address || ""}
				/>
				<div className="row mb-2 ">
					<div className="col-lg-6">
						<label className="form-label text-capitalize">
							{trans("Start Date")}
						</label>
						<Space>
							<DatePicker
								title={trans("Start Date")}
								id="startDate"
								name="startDate"
								onBlur={(value) => addPOI.setFieldTouched("startDate", true)}
								value={startDateValue} // ✅ always dayjs | null
								onChange={(value) => {
									addPOI.setFieldValue(
										"startDate",
										value ? value.toISOString() : null,
									);
								}}
								errors={addPOI.errors.startDate}
								touched={addPOI.touched.startDate}
							/>
						</Space>
						{/* <div>
                                    {errors && touched ? (
                                        <div className="validation">{trans(errors)}</div>
                                    ) : (
                                        ""
                                    )}
                                </div> */}
					</div>
					<div className="col-lg-6">
						<label className="form-label text-capitalize">
							{trans("End Date")}
						</label>
						<Space>
							<DatePicker
								title={trans("End Date")}
								id="endDate"
								name="endDate"
								onBlur={(value) => addPOI.setFieldTouched("endDate", true)}
								value={endDateValue} // ✅ always dayjs | null
								onChange={(value) => {
									addPOI.setFieldValue(
										"endDate",
										value ? value.toISOString() : null,
									);
								}}
								errors={addPOI.errors.endDate}
								disabledDate={disabledEndDate}
								touched={addPOI.touched.endDate}
							/>
						</Space>
						{/* <div>
                                    {errors && touched ? (
                                        <div className="validation">{trans(errors)}</div>
                                    ) : (
                                        ""
                                    )}
                                </div> */}
					</div>
				</div>

				<Dropfile name="attachments" addData={addPOI} />
				<POIsLogo addPOI={addPOI} />
			</div>
		</div>
	);
}
